import { useQuery } from '@apollo/client'
import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import { IGetKitStatusInput, IGetKitStatusOutput } from '../../../graphql/types/queries/kit'
import { GET_KIT_STATUS } from '../../../graphql/queries'
import PleaseWait from '../../../components/PleaseWait'
import moment from 'moment'

interface IKitStatusProps {
  labResultId: string
}

export const KitStatus: React.FC<IKitStatusProps> = ({ labResultId }) => {
  const { data, loading, error } = useQuery<IGetKitStatusOutput, IGetKitStatusInput>(GET_KIT_STATUS, {
    variables: {
      labResultId
    }
  })

  if (!!loading) {
    return (
      <Flex flex={1} justifyContent={'center'} alignItems={'center'}>
        <PleaseWait />
      </Flex>
    )
  }

  if (!!error) {
    return (
      <Flex flex={1} justifyContent={'center'} alignItems={'center'}>
        <Text>An error occured</Text>
      </Flex>
    )
  }

  if (!data || !data.healthCoachGetKitStatus) {
    return (
      <Flex flex={1} justifyContent={'center'} alignItems={'center'}>
        <Text>No information found</Text>
      </Flex>
    )
  }
  return (
    <Flex flexDirection={'column'}>
      <Heading mb={4} textAlign={'center'}>Kit Status</Heading>
      <Text fontWeight={600}>Information:</Text>
      <Flex flexDirection={'column'} ml={3}>
        <Flex mb={3} flexDirection={'column'}>
          <Text fontWeight={300}>Barcode: </Text>
          <Text fontWeight={600} ml={2}>{data.healthCoachGetKitStatus.barcode}</Text>
        </Flex>
        <Flex mb={3} flexDirection={'column'}>
          <Text fontWeight={300}>Status: </Text>
          <Text fontWeight={600} ml={2}>{data.healthCoachGetKitStatus.status}</Text>
        </Flex>
        <Flex mb={3} flexDirection={'column'}>
          <Text fontWeight={300}>Date kit delivered to customer: </Text>
          <Text fontWeight={600} ml={2}>{data.healthCoachGetKitStatus.deliveryToPatientDate}</Text>
        </Flex>
        <Flex mb={3} flexDirection={'column'}>
          <Text fontWeight={300}>Date kit delivered to lab: </Text>
          <Text fontWeight={600} ml={2}>{data.healthCoachGetKitStatus.deliveryToLabDate}</Text>
        </Flex>
        <Flex mb={3} flexDirection={'column'}>
          <Text fontWeight={300}>Business days since lab receipt: </Text>
          <Text fontWeight={600} ml={2}>{data.healthCoachGetKitStatus.businessDaysSinceLabReceipt}</Text>
        </Flex>
        <Flex mb={3} flexDirection={'column'}>
          <Text fontWeight={300}>Slow lab flag: </Text>
          <Text fontWeight={600} ml={2}>{data.healthCoachGetKitStatus.slowLabFlag || 'No'}</Text>
        </Flex>

      </Flex>
      <Text fontWeight={600} mt={3}>ETAs:</Text>
      <Flex flexDirection={'column'} ml={3}>
        <Flex mb={3} flexDirection={'column'}>
          <Text fontWeight={300}>Kit to customer: </Text>
          <Text fontWeight={600} ml={2}>{data.healthCoachGetKitStatus.etaToCustomer}</Text>
        </Flex>
        <Flex mb={3} flexDirection={'column'}>
          <Text fontWeight={300}>Sample to lab: </Text>
          <Text fontWeight={600} ml={2}>{data.healthCoachGetKitStatus.etaToLab}</Text>
        </Flex>
        <Flex mb={3} flexDirection={'column'}>
          <Text fontWeight={300}>Results ETA: </Text>
          <Text fontWeight={600} ml={2}>{data.healthCoachGetKitStatus.etaResults}</Text>
        </Flex>
        <Flex mb={3} flexDirection={'column'}>
          <Text fontWeight={300}>Track kit to customer: </Text>
          <Text fontWeight={600} ml={2} style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => {
            if (!data.healthCoachGetKitStatus || !data.healthCoachGetKitStatus.trackKitToCustomer) return
            window.open(data.healthCoachGetKitStatus.trackKitToCustomer, '_blank')
          }}>{data.healthCoachGetKitStatus.trackKitToCustomer}</Text>
        </Flex>
        <Flex mb={3} flexDirection={'column'}>
          <Text fontWeight={300}>Track kit to lab: </Text>
          <Text fontWeight={600} ml={2} style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => {
            if (!data.healthCoachGetKitStatus || !data.healthCoachGetKitStatus.trackKitToLab) return
            window.open(data.healthCoachGetKitStatus.trackKitToLab, '_blank')
          }}>{data.healthCoachGetKitStatus.trackKitToLab}</Text>
        </Flex>
        <Flex mb={3} flexDirection={'column'}>
          <Text fontWeight={300}>Order Id (Stripe): </Text>
          <Text fontWeight={600} ml={2} style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => {
            if (!data.healthCoachGetKitStatus || !data.healthCoachGetKitStatus.orderId) return
            window.open(`https://dashboard.stripe.com/orders/${data.healthCoachGetKitStatus.orderId}`, '_blank')
          }}>{data.healthCoachGetKitStatus.orderId}</Text>
        </Flex>
        <Flex mb={3} flexDirection={'column'}>
          <Text fontWeight={300}>Allied Ref Number: </Text>
          <Text fontWeight={600} ml={2}>{data.healthCoachGetKitStatus.alliedRef}</Text>
        </Flex>

      </Flex>
    </Flex>);
}